import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import { SystemUpdate } from '@mui/icons-material';
import { subscribeToServiceWorkerState, updateServiceWorker, getServiceWorkerState } from '../utils/serviceWorker';

export default function UpdateAvailableDialog() {
  const [updateAvailable, setUpdateAvailable] = useState(getServiceWorkerState().updateAvailable);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToServiceWorkerState((state) => {
      setUpdateAvailable(state.updateAvailable);
      if (state.updateAvailable) {
        setOpen(true);
      }
    });

    return unsubscribe;
  }, []);

  const handleUpdate = () => {
    updateServiceWorker();
    setOpen(false);
  };

  const handleDismiss = () => {
    setOpen(false);
  };

  if (!updateAvailable) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={handleDismiss}
      aria-labelledby="update-dialog-title"
      aria-describedby="update-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="update-dialog-title">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SystemUpdate />
          Update Available
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="update-dialog-description">
          A new version of Glasska ERP is available. Would you like to update now?
          The app will reload after updating.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDismiss} color="inherit">
          Later
        </Button>
        <Button onClick={handleUpdate} variant="contained" color="primary" autoFocus>
          Update Now
        </Button>
      </DialogActions>
    </Dialog>
  );
}
